import { useAuth } from "@features/auth/hooks/useAuth.ts"
import { LogisticsPermissions, logisticsPermissions } from "@shared/utils/logistics-permissions"

/** Qué puede hacer en Logística el usuario actual (ver `shared/utils/logistics-permissions.ts`) */
export const useLogisticsPermissions = (): LogisticsPermissions => {
  const { hasRole } = useAuth()
  return logisticsPermissions(hasRole)
}
